import React, { useEffect } from "react";
import { useNavV5 } from "@/features/accountNavV5/lib/useNavV5";
import { arPreviewFromSearch, getArPreview, setArPreview } from "@/shared/config/arabicUi";

/**
 * ?ar_preview=1 в адресе — админ включает предпросмотр арабского на этом
 * устройстве; ?ar_preview=0 — выключает (это может кто угодно: только убирает).
 * App ставит компонент лишь когда параметр есть, поэтому список админов
 * ради него запрашивается только по таким ссылкам.
 */
export const ArabicPreviewParam: React.FC<{ search: string }> = ({ search }) => {
    const want = arPreviewFromSearch(search);
    const { isRealAdmin, loading } = useNavV5();
    useEffect(() => {
        if (want === false) {
            if (getArPreview()) setArPreview(false);
            return;
        }
        if (want !== true || loading || !isRealAdmin) return;
        if (!getArPreview()) setArPreview(true);
    }, [want, loading, isRealAdmin]);
    return null;
};
